import * as UtilityAccordion from "../utilities/u-accordion";
import { addClassForCloseAnimation, convertCssAniDurationToMS } from "../utilities/helper-function";

class CollapseFilter {
    constructor(element) {
        this.collapseFilter = element;
        this.triggerBtn = this.collapseFilter.querySelector('.collapse-filter__header');
        this.triggerBtnId = this.triggerBtn.id;
        this.collapseFilterBody = this.collapseFilter.querySelector('.collapse-filter__base');
        this.collapseFilterBodyId = this.collapseFilterBody.id;
        this.collapseFilterCheckboxes = this.collapseFilter.querySelectorAll('.checkbox-btn__input');

        this.accordionStartFrom = this.collapseFilter.dataset.accordionStartFrom;
        if(this.accordionStartFrom !== undefined) {
            this.overlayId = "";
            this.overlayWrapper;
            this.overlayCheckboxes;
        }

        this.rootStyles = getComputedStyle(document.documentElement);
        this.aniSlow= convertCssAniDurationToMS(this.rootStyles.getPropertyValue('--ani--slow').trim());

        this.mobileBreakpoint = 768;
        this.setAccordionFunction = true;
        this.lastWindowSize = 0;

        window.addEventListener('load', () => {
            if(this.accordionStartFrom !== undefined) {
                this.overlayId = this.triggerBtn.dataset.targetId;
                this.overlayWrapper = document.getElementById(this.overlayId).parentElement;
                this.overlayCheckboxes = this.overlayWrapper.querySelectorAll('.checkbox-btn__input');

                if(this.overlayCheckboxes) {
                    this.overlayCheckboxes.forEach((checkbox) => {
                        checkbox.addEventListener('change', (e) => {
                            this.syncCheckboxStatus(e, false);
                        })
                    })
                }
            }

            if(this.accordionStartFrom && this.accordionStartFrom === "tablet" && window.innerWidth < this.mobileBreakpoint) {
                this.setAccordionFunction = false;
            } else {
                this.setAccordionFunction = true;
                this.initialiseAccordion();
                this.removeOverlayDataset();
            }
        })

        window.addEventListener('resize', () => {
            if(this.accordionStartFrom === undefined) return;

            if(window.innerWidth < this.lastWindowSize) {
                // when resize smaller and over breakpoint
                if(this.lastWindowSize >= this.mobileBreakpoint && window.innerWidth < this.mobileBreakpoint) {
                    if(this.collapseFilter.classList.contains('collapse-filter--open')) {
                        this.closeAccordion();
                        UtilityAccordion.slideUp(this.collapseFilterBody, this.aniSlow);
                    }
                    this.initialiseOverlay();
                    this.removeAccordionAttribute();
                    this.setAccordionFunction = false;
                }
            } else {
                // when resize larger and over breakpoint
                if(this.lastWindowSize < this.mobileBreakpoint && window.innerWidth >= this.mobileBreakpoint) {
                    //close overlay
                    this.closeOverlay();
                    this.initialiseAccordion();
                    this.removeOverlayDataset();
                    this.setAccordionFunction = true;
                }
            }

            this.lastWindowSize = window.innerWidth === 0 ? 0 : window.innerWidth;
        })

        this.triggerBtn.addEventListener('click', () => {
            if(this.setAccordionFunction) {
                this.toggleAccordion();
            }
        })

        if(this.accordionStartFrom !== undefined) {
            this.collapseFilterCheckboxes.forEach((checkbox) => {
                checkbox.addEventListener('change', (e) => {
                    this.syncCheckboxStatus(e, true);
                })
            })
        }

    }

    // Initialise
    initialiseAccordion() {
        this.triggerBtn.setAttribute('aria-expanded', false);
        this.triggerBtn.setAttribute('aria-controls', this.collapseFilterBodyId);
        this.collapseFilterBody.setAttribute('aria-labelledby', this.triggerBtnId);
        this.collapseFilterBody.setAttribute('role', "region");
    }

    initialiseOverlay() {
        this.triggerBtn.setAttribute('data-target', "overlay");
        this.triggerBtn.setAttribute('data-target-id', this.overlayId);
        this.triggerBtn.setAttribute('data-overlay-action', "open");
    }

    removeAccordionAttribute() {
        this.triggerBtn.removeAttribute('aria-expanded');
        this.triggerBtn.removeAttribute('aria-controls');
        this.collapseFilterBody.removeAttribute('aria-labelledby');
        this.collapseFilterBody.removeAttribute('role');
    }

    removeOverlayDataset() {
        this.triggerBtn.removeAttribute('data-target');
        this.triggerBtn.removeAttribute('data-target-id');
        this.triggerBtn.removeAttribute('data-overlay-action');
    }

    toggleAccordion() {
        if(this.collapseFilter.classList.contains('collapse-filter--open')) {
            this.closeAccordion();
        } else {
            this. openAccordion();
        }
        UtilityAccordion.slideToggle(this.collapseFilterBody, this.aniSlow);
    }

    openAccordion() {
        this.collapseFilter.classList.add('collapse-filter--open');
        this.triggerBtn.setAttribute('aria-expanded', true);
    }

    closeAccordion() {
        this.collapseFilter.classList.remove('collapse-filter--open');
        this.triggerBtn.setAttribute('aria-expanded', false);
        addClassForCloseAnimation(this.collapseFilter, "collapse-filter--close",this.aniSlow);
    }

    closeOverlay() {
        this.overlayWrapper.classList.remove("overlay--open");
        addClassForCloseAnimation(this.overlayWrapper, "overlay--close", this.aniFast)
    }

    syncCheckboxStatus(e, fromAccordion) {
        const name= e.target["name"];
        const value = e.target["value"];

        const targetArea = fromAccordion ? document.getElementById(this.overlayId) : this.collapseFilterBody;
        const targetCheckbox = targetArea.querySelector(`.checkbox-btn__input[name="${name}"][value="${value}"]`);
        targetCheckbox.checked = e.target.checked;
    }
}

export default CollapseFilter;